import { CustomWaypoint } from '@/components/CustomWaypoint'
import { PageSection } from '@/components/PageSection'
import type { PageSection as Section } from '@/layouts/components/Sidebar'

import { PoleasImportState, usePoleasImportContext } from '@/context/PoleasImportProvider'
import { useSidebar } from '@/context/SidebarContext'
import { Stack } from '@chakra-ui/react'
import { useEffect } from 'react'
import { ImportPreviewForm } from './forms/ImportPreviewForm'
import { NewImportForm } from './forms/NewImportForm'


export const PoleasImportSections = {
  Parameters: 'parameters',
  Preview: 'preview',
}
export type PoleasImportSections = typeof PoleasImportSections[keyof typeof PoleasImportSections]

export const PoleasImport = () => {

  const { pageSections, setPageSections } = useSidebar()

  const { importState } = usePoleasImportContext()

  useEffect(() => {
    let i = 1
    const array: Section[] = [
      {
        id: PoleasImportSections.Parameters,
        sectionTitle: 'Nový import nabídek',
        index: i,
        children: (
          <NewImportForm
            sectionNumber={i++}
            sectionTitle='Nový import nabídek'
          />
        )
      }]

    if (importState == PoleasImportState.preview) {
      array.push({
        id: PoleasImportSections.Preview,
        sectionTitle: 'Náhled importu',
        index: i,
        children: (
          <ImportPreviewForm />
        )
      })
    }

    setPageSections(array)
  }, [importState])

  return (
    <Stack gap={8}>
      {pageSections.map(x => (
        <CustomWaypoint key={x.id} sectionId={x.id}>
          <PageSection id={x.id}>
            {x.children}
          </PageSection>
        </CustomWaypoint>
      ))}

    </Stack>
  )
}